import React from 'react';
import propTypes from 'prop-types';
import { useParams } from 'react-router-dom';
;
import { Button, Columns, Column, Subtitle } from 'src/ui/mui-ui-kit';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { find } from 'lodash';
import dayjs from 'dayjs-ext';
import { DEFAULT_DATE_FORMAT, DATE_DAY_SMONTH_YEAR } from 'src/ui/const';

function isPast(date) {
  return dayjs().isAfter(dayjs(date, { format: DEFAULT_DATE_FORMAT }));
}

function BadgeList({ account, onEditBadge, onAddBadge, onDeleteBadge }) {
  const { id } = useParams();
  const person = find(account.people, { id: +id });

  const badges = person.badges || [];

  return (
    <>
      <div className="buttons is-right">
        <Button isColor="gradient-bright" onClick={onAddBadge}>
          <span className="icon">
            <FontAwesomeIcon icon={['fal', 'plus']} />
          </span>
          <span>Badge</span>
        </Button>
      </div>
      {badges.map(badge => {
        const location = find(account.locations, { id: badge.locationId });

        return (
          <div key={badge.id} style={{ height: '55px' }}>
            {' '}
            {/* TODO(Matheus): please fix style in a more Bulma-friendly way */}
            <Columns isVCentered>
              <Column isSize="narrow">
                <span className="icon is-medium has-icon-gradient-bright is-block">
                  <FontAwesomeIcon icon={['fas', 'id-badge']} size="2x" />
                </span>
              </Column>
              <Column>
                <Subtitle hasTextColor="primary" tag="h4" className="is-size-6">
                  {badge.badgeNumber}
                </Subtitle>
              </Column>
              <Column hasTextAlign="centered">
                <small className="has-text-grey-medium-dark">
                  {location && location.type}
                </small>
              </Column>
              <Column hasTextAlign="centered">
                <small
                  className={
                    isPast(badge.badgeDateExpired)
                      ? 'has-text-danger'
                      : 'has-text-info'
                  }
                >
                  {badge.badgeDateExpired &&
                    dayjs(badge.badgeDateExpired, {
                      format: DEFAULT_DATE_FORMAT,
                    }).format(DATE_DAY_SMONTH_YEAR)}
                </small>
              </Column>
              <Column>
                <div className="buttons is-right has-addons">
                  <Button
                    isColor="white"
                    isSize="small"
                    onClick={() => onEditBadge(badge)}
                  >
                    <span className="icon is-small has-icon-gradient-bright">
                      <FontAwesomeIcon icon={['fal', 'edit']} />
                    </span>
                  </Button>
                  <Button
                    isColor="white"
                    isSize="small"
                    onClick={() => onDeleteBadge(badge)}
                  >
                    <span className="icon is-small has-icon-gradient-bright">
                      <FontAwesomeIcon icon={['fal', 'trash-alt']} />
                    </span>
                  </Button>
                </div>
              </Column>
            </Columns>
          </div>
        );
      })}
    </>
  );
}

BadgeList.propTypes = {
  account: propTypes.object.isRequired,
  onAddBadge: propTypes.func.isRequired,
  onEditBadge: propTypes.func.isRequired,
  onDeleteBadge: propTypes.func.isRequired,
};

export { BadgeList };
